import React from 'react'

const GetQuoteIcon = (props)=>(
    <svg width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M2.45 19.218v-18.463h-1.606v20.069h20.069v-1.605h-18.463zm1.711-15.08h8.372v1.606h-8.372v-1.606zm0 5.027h15.08v1.606h-15.08v-1.606zm0 5.027h11.726v1.605h-11.726v-1.605z" fill={props.fill}/></svg>
)

export default GetQuoteIcon
